(function(angular){
	'use strict';
	
	angular.module('topQuestionsModule', [
		'allocationBreakdownTableModule',
		'coreModule'
	]);

})(window.angular);